<template>
  <div class="content-page">
    <div class="tab-content">
      <el-form
        :model="shopForm"
        :rules="rules"
        ref="shopForm"
        label-width="98px"
        class="shopsetting-form"
        width="328px"
        :hide-required-asterisk="true"
      >
        <el-form-item label="配送范围" prop="sendScope">
          <el-input
            v-model="shopForm.sendScope"
            placeholder="请填写配送范围"
            type="number"
            onchange="this.value=this.value.replace(/[^\d]/g,'')"
          ></el-input
          >&nbsp;公里
        </el-form-item>
        <el-form-item label="配送方式" prop="sendType">
          <el-select v-model="shopForm.sendType" placeholder="请选择配送方式">
            <el-option
              v-for="(item, index) in sendTypeList"
              :key="index"
              :label="item.name"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="基础配送费" prop="distributionPrice">
          <el-input
            v-model="shopForm.distributionPrice"
            placeholder="请填写配送费"
            type="number"
            onchange="this.value=this.value.replace(/[^\d]/g,'')"
          ></el-input
          >&nbsp;元（一公里内）
        </el-form-item>
        <el-form-item label="免配送额" prop="minDistributionPrice">
          <el-input
            v-model="shopForm.minDistributionPrice"
            placeholder="请填写免配送额"
            type="number"
            onchange="this.value=this.value.replace(/[^\d]/g,'')"
          ></el-input
          >&nbsp;元
        </el-form-item>
        <el-form-item label="起送价" prop="toSendPrice">
          <el-input
            v-model="shopForm.toSendPrice"
            placeholder="请填写起送价"
            type="number"
          ></el-input
          >&nbsp;元
        </el-form-item>
        <el-form-item label="当日可自提" prop="isTodayPick">
          <el-radio-group v-model="shopForm.isTodayPick">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="自动发单" prop="isAutoDelivery">
          <el-radio-group v-model="shopForm.isAutoDelivery">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio> </el-radio-group
          >&nbsp;(配置第三方配送，外卖订单支付后自动给第三方配送发单)
        </el-form-item>
        <el-form-item label="阶梯配送费">
          <div class="delivery-template">
            <div
              class="item"
              v-for="(item, index) in shopForm.deliveryTemplate"
              :key="index"
            >
              <el-input-number
                v-model="item.from"
                :precision="0"
                :step="1"
                :min="index ? shopForm.deliveryTemplate[index - 1].to : 1"
                placeholder="公里数"
                size="small"
              ></el-input-number
              >&nbsp;km 至&nbsp;
              <el-input-number
                v-model="item.to"
                :precision="0"
                :step="1"
                :min="shopForm.deliveryTemplate[index].from + 1"
                placeholder="公里数"
                size="small"
              ></el-input-number
              >&nbsp;km&nbsp;
              <el-input-number
                v-model="item.unit"
                :precision="0"
                :step="1"
                :min="1"
                placeholder="费用"
                size="small"
              ></el-input-number
              >&nbsp; 元/km
              <el-button
                class="button-del"
                type="danger"
                size="medium"
                @click="delDeliveryTemplateList(index)"
              >
                删除</el-button
              >
            </div>
            <el-button
              v-if="shopForm.deliveryTemplate.length < 5"
              class="button-add"
              size="medium"
              @click="addDeliveryTemplateList()"
              >+ 添加</el-button
            >
          </div>
        </el-form-item>
        <el-form-item class="submit-btn-container">
          <el-button type="primary" @click="submitForm('shopForm')">保存</el-button>
          <el-button @click="resetForm()">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- <baidu-map v-if="showMap" class="index-map"></baidu-map> -->
  </div>
</template>

<script>
import {
  getShopCategorys,
  uploadImg,
  modifyShopInfo,
  getShopInfo,
  getMerchantMT,
} from "@/api/index.js";
import { mapState, mapActions } from "vuex";
import { gg2bd, bd2gg } from "@/utils/map.js";
import qrcode from "@xkeshi/vue-qrcode";
import html2canvas from "html2canvas";
import uploadImgComponent from "@/components/uploadImg";
let id = 0;
import { commonFuc } from "@/mixins/commonFuc";

export default {
  mixins: [commonFuc],
  data() {
    return {
      shopCategoryIdTagsOptions: [],
      dialogImageUrl: "",
      dialogVisible: false,
      shopForm: {
        shopLogo: "",
        edcShopQRcode: "",
        shopName: "",
        shopNotice: "",
        shopTel: "",
        businessHours: "",
        startTime: "",
        endTime: "",
        cityName: "",
        shopAddress: "",
        edcfuncTags: "",
        takeoutStatus: true,
        tangStatus: true,
        shopCategoryIdTags: [1, 1],
        needChoosePeopleNum: 1,
        payMethod: 1,
        isAutoClearTable: 1,
        isAutoOrderNumber: 1,
        mealMethod: 1,
        sendScope: "",
        sendType: 1,
        distributionPrice: "",
        minDistributionPrice: "",
        toSendPrice: "",
        isTodayPick: 0,
        isAutoDelivery: 1,
        shopFaceImage: "",
        shopImages: "",
        bannerImage: "",
        indexBackgroundImage: "",
        isVerified: 0,
        nuonuoTaxNum: "",
        deliveryTemplate: [],
      },
      rules: {
        sendScope: [
          {
            required: true,
            message: "请填写配送范围",
            trigger: "blur",
          },
        ],
        distributionPrice: [
          {
            required: true,
            message: "请填写配送费",
            trigger: "blur",
          },
        ],
        toSendPrice: [
          {
            required: true,
            message: "请填写起送价",
            trigger: "blur",
          },
        ],
      },
      shopLogo: [],
      shopFaceImage: [],
      shopImages: [],
      bannerImage: [],
      indexBackgroundImage: [],
      dialogMapVisible: false,
      mapCenter: "",
      center: { lng: 0, lat: 0 },
      zoom: 12.8,
      keyword: "",
      location: "",
      show: false,
      postionMap: {
        //地图坐标
        lng: 120.211486,
        lat: 30.256576,
      },
      add: {
        siteName: "",
        site: "",
        jd: "",
        wd: "",
        desce: "",
        type: "",
        jgName: "",
        jgNum: "",
      },
      showMap: false,
      sendTypeList: [
        {
          name: "商家配送",
          value: 1,
        },
        {
          name: "达达配送",
          value: 2,
        },
        // {
        //   name: "蜂鸟配送",
        //   value: 3,
        // },
        // {
        //   name: "闪送配送",
        //   value: 4,
        // },
        // {
        //   name: "美团配送",
        //   value: 5,
        // },
        {
          name: "聚合配送",
          value: 6,
        },
      ],
      isshow_uploadDialog: false,
      uploadDisabled: false,
      ImgLimits: 0,
      uploadName: "",
    };
  },
  computed: {
    ...mapState({
      shop: (state) => state.shopInfo,
    }),
  },
  components: {
    qrcode,
    uploadImgComponent,
  },
  mounted() {
    this.getPageData();
  },
  methods: {
    getChoose_ImgUrl(val, name) {
      console.log(val, name);
      if (val.length > 0) {
        this.isshow_uploadDialog = false;
        this.uploadDisabled = false;
        val.forEach((item) => {
          if (name == "shopImages") {
            if (this.shopForm[name].length) {
              this.shopForm[name] += `,${item.image}`;
            } else {
              this.shopForm[name] = item.image;
            }
            this.shopImages.push({ name: "", url: item.image });
            return;
          }
          this.shopForm[name] = item.image;
          switch (name) {
            case "shopLogo":
              this.shopLogo = [];
              this.shopLogo.push({ name: "", url: item.image });
              break;
            case "shopFaceImage":
              this.shopFaceImage = [];
              this.shopFaceImage.push({ name: "", url: item.image });
              break;
            case "bannerImage":
              this.bannerImage = [];
              this.bannerImage.push({ name: "", url: item.image });
              break;
            case "indexBackgroundImage":
              this.indexBackgroundImage = [];
              this.indexBackgroundImage.push({ name: "", url: item.image });
              break;
            default:
              console.log("111");
          }
        });
      }
      this.$refs["shopForm"].validate();
    },
    ...mapActions(["updateShopInfo"]),
    getPageData() {
      getMerchantMT().then((res) => {
        if (res.code == 1) {
          if (res.data && res.data.status == 2) {
            this.sendTypeList.push({
              name: "美团配送",
              value: 5,
            });
          }
        }
      });
      this.getShopCategorys();
      this.showMap = true;
      setTimeout(() => {
        this.showMap = false;
        getShopInfo().then((shopInfo) => {
          this.updateShopInfo(shopInfo.data);
          let shopForm = JSON.parse(JSON.stringify(this.shop));
          let { lng, lat } = gg2bd(shopForm.longitude, shopForm.latitude);
          this.shopLogo = shopForm.shopLogo.length ? [{ url: shopForm.shopLogo }] : [];
          this.shopFaceImage = shopForm.shopFaceImage.length
            ? [{ url: shopForm.shopFaceImage }]
            : [];
          this.bannerImage = shopForm.bannerImage.length
            ? [{ url: shopForm.bannerImage }]
            : [];
          this.indexBackgroundImage = shopForm.indexBackgroundImage.length
            ? [{ url: shopForm.indexBackgroundImage }]
            : [];
          let shopImages = shopForm.shopImages.split(",");
          if (shopImages[0].length) {
            shopImages.forEach((val) => {
              this.shopImages.push({
                name: val,
                url: val,
              });
            });
          }
          console.log(this.shopImages);
          shopForm.startTime = shopForm.businessHours.split("-")[0];
          shopForm.endTime = shopForm.businessHours.split("-")[1];
          shopForm.takeoutStatus = ~shopForm.edcfuncTags.indexOf("1") ? true : false;
          shopForm.tangStatus = ~shopForm.edcfuncTags.indexOf("2") ? true : false;
          let shopCategoryIdTags = shopForm.shopCategoryIdTags.split(",").map((val) => {
            return Number(val);
          });
          shopForm.shopCategoryIdTags = shopCategoryIdTags;
          shopForm.deliveryTemplate = shopForm.deliveryTemplate
            ? JSON.parse(shopForm.deliveryTemplate)
            : [];
          this.shopForm = shopForm;
          // let point = new BMap.Point(lng, lat);
          // let geocoder = new BMap.Geocoder(); //创建地址解析器的实例
          // geocoder.getLocation(point, (rs) => {
          //   shopForm.cityName = [
          //     rs.addressComponents.province,
          //     rs.addressComponents.city,
          //     rs.addressComponents.district,
          //   ];
          //   console.log([
          //     rs.addressComponents.province,
          //     rs.addressComponents.city,
          //     rs.addressComponents.district,
          //   ]);
          //   this.mapCenter = shopForm.cityName.join("");
          // });
        });
      }, 500);
    },
    getShopCategorys() {
      getShopCategorys().then((res) => {
        if (res.code == 1) {
          let options = Array.from(res.data).map((item) => ({
            value: item.shopCategoryId,
            label: item.categoryName,
            children: [],
          }));
          options.forEach((val, index) => {
            getShopCategorys({
              shopCategoryId: val.value,
            }).then((res) => {
              if (res.code == 1) {
                let subOptions = Array.from(res.data).map((item) => ({
                  value: item.shopCategoryId,
                  label: item.categoryName,
                }));
                val.children = subOptions;
                this.shopCategoryIdTagsOptions = options;
              }
            });
          });
        }
      });
    },
    downQrcode() {
      let shareContent = document.getElementById("qrcode"); // 需要绘制的部分的 (原生）dom 对象 ，注意容器的宽度不要使用百分比，使用固定宽度，避免缩放问题
      let width = shareContent.offsetWidth; // 获取(原生）dom 宽度
      let height = shareContent.offsetHeight; // 获取(原生）dom 高
      let offsetTop = shareContent.offsetTop; //元素距离顶部的偏移量
      let canvas = document.createElement("canvas"); //创建canvas 对象
      let context = canvas.getContext("2d");
      let scaleBy = 4; //main.getPixelRatio(context);  //获取像素密度的方法 (也可以采用自定义缩放比例)
      canvas.width = 2.3 * width * scaleBy; //这里 由于绘制的dom 为固定宽度，居中，所以没有偏移
      canvas.height = 2 * (height + offsetTop) * scaleBy; // 注意高度问题，由于顶部有个距离所以要加上顶部的距离，解决图像高度偏移问题
      context.scale(scaleBy, scaleBy);
      html2canvas(document.getElementById("qrcode"), {
        useCORS: true,
        tainttest: true, //检测每张图片都已经加载完成
        scale: scaleBy, // 添加的scale 参数
        canvas: canvas, //自定义 canvas
        logging: false, //日志开关，发布的时候记得改成false
        width: width, //dom 原始宽度
        height: height, //dom 原始高度
      }).then((canvas) => {
        let dataURL = canvas.toDataURL("image/jpeg", 1.0);
        var a = document.createElement("a"); // 创建一个a节点插入的document
        var event = new MouseEvent("click"); // 模拟鼠标click点击事件
        a.download = "shop-qrcode.png"; // 设置a节点的download属性值
        a.href = dataURL; // 将图片的src赋值给a节点的href
        a.dispatchEvent(event);
      });
    },
    handleRemove(file, name) {
      console.log(file, name);
      if (name == "shopImages") {
        let shopImages1 = this.shopForm.shopImages.split(",");
        let shopImages2 = this.shopForm.shopImages.split(",");
        shopImages1.splice(shopImages1.indexOf(file.url), 1);
        this.shopForm.shopImages = shopImages1.join(",");
        this.shopImages.splice(shopImages2.indexOf(file.url), 1);
      } else {
        this.shopForm[name] = "";
      }
    },
    beforeRemove(file, fileList) {},
    limitTip(files, fileList) {
      this.$notify({
        title: "警告",
        message: "只能上传一张图片，请删除图片后再上传",
        type: "warning",
        duration: 6000,
      });
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    beforeImgUpload(file) {
      const isLt3M = file.size / 1024 / 1024 < 3;
      if (!isLt3M) {
        this.$notify.error("上传图片大小不能超过 3MB!");
      }
      return isLt3M;
    },
    handleSuccess(item, name) {
      let imgUploadForm = new FormData();
      imgUploadForm.append("file", item.file);
      imgUploadForm.append("fileContentType", item.file.type);
      imgUploadForm.append("fileFileName", item.file.name);
      imgUploadForm.append("isCompre", 1);
      imgUploadForm.append("isCutImage", 1);
      uploadImg(imgUploadForm).then((res) => {
        if (res.code == 1) {
          if (name == "shopImages") {
            if (this.shopForm[name].length) {
              this.shopForm[name] += `,${res.data.url}`;
            } else {
              this.shopForm[name] = res.data.url;
            }
            return;
          }
          this.shopForm[name] = res.data.url;
        }
      });
    },
    submitForm(formName, cb) {
      console.log(this.shopForm, "shopForm");
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let shopForm = JSON.parse(JSON.stringify(this.shopForm));
          shopForm.businessHours = `${shopForm.startTime}-${shopForm.endTime}`;
          shopForm.edcfuncTags = "";
          shopForm.edcfuncTags = shopForm.takeoutStatus ? "1" : "";
          shopForm.edcfuncTags +=
            shopForm.tangStatus && shopForm.takeoutStatus
              ? ",2"
              : shopForm.tangStatus
              ? "2"
              : "";
          shopForm.shopCategoryId = shopForm.shopCategoryIdTags[1] || "";
          shopForm.shopCategoryIdTags = shopForm.shopCategoryIdTags.join(",");
          shopForm.cityName = JSON.stringify(shopForm.cityName);
          shopForm.bannerImage = shopForm.bannerImage.length
            ? shopForm.bannerImage
            : "https://api.yichengshi.cn/images/edcmobile/default_banner.png";
          shopForm.coodinateSystemType = 4;
          let isErr = false;
          let errText = "";
          shopForm.deliveryTemplate.forEach((val, index) => {
            if (val.to <= val.from) {
              isErr = true;
              errText = "截止公里数不能小于等于起始公里数";
            }
            if (index && val.from < shopForm.deliveryTemplate[index - 1].to) {
              isErr = true;
              errText = "起始公里数不能小于上一阶梯截止公里数";
            }
          });
          if (isErr) {
            return this.$notify.error(errText);
          }
          shopForm.deliveryTemplate = JSON.stringify(shopForm.deliveryTemplate);
          modifyShopInfo(shopForm).then((res) => {
            if (res.code == 1) {
              getShopInfo().then((shopInfo) => {
                this.updateShopInfo(shopInfo.data);
                if (cb) {
                  cb(shopInfo.data);
                  return;
                }
                this.$notify({
                  title: "提示",
                  message: "保存成功",
                  type: "success",
                  duration: 2000,
                });
                // this.$router.push({
                //   path: "/",
                // });
              });
            } else {
              if (res.code == 11) {
                this.$notify({
                  title: "提示",
                  message: "如需在线支付，请申请网付认证",
                  type: "warning",
                  duration: 2000,
                });
                return;
              }
              this.$notify({
                title: "提示",
                message: res.msg,
                type: "warning",
                duration: 2000,
              });
            }
          });
        } else {
          this.$notify({
            title: "提示",
            message: "表单未完善，请检查店铺设置",
            type: "error",
            duration: 2000,
          });
          return false;
        }
      });
    },
    resetForm() {
      (this.shopForm = {
        shopLogo: "",
        edcShopQRcode: "",
        shopName: "",
        shopNotice: "",
        shopTel: "",
        businessHours: "",
        startTime: "",
        endTime: "",
        cityName: "",
        shopAddress: "",
        edcfuncTags: "",
        takeoutStatus: true,
        tangStatus: true,
        shopCategoryIdTags: [1, 1],
        needChoosePeopleNum: 1,
        payMethod: 1,
        isAutoClearTable: 1,
        isAutoOrderNumber: 1,
        mealMethod: 1,
        sendScope: "",
        sendType: 1,
        distributionPrice: "",
        minDistributionPrice: "",
        toSendPrice: "",
        isTodayPick: 0,
        isAutoDelivery: 1,
        shopFaceImage: "",
        shopImages: "",
        bannerImage: "",
        indexBackgroundImage: "",
        isVerified: this.shopForm.isVerified,
        deliveryTemplate: [],
      }),
        (this.shopLogo = []);
      this.shopFaceImage = [];
      this.shopImages = [];
      this.bannerImage = [];
      this.indexBackgroundImage = [];
      this.$refs.shopForm.resetFields();
    },
    mapReadyHandler({ BMap, map }) {
      this.center = this.mapCenter;
      console.log(this.mapCenter);
      this.zoom = 12.8;
    },
    getPoint(e) {
      //点击地图获取一些信息，
      this.show = true;
      this.postionMap.lng = e.point.lng; //通过  e.point.lng获取经度
      this.postionMap.lat = e.point.lat; //通过  e.point.lat获取纬度
      this.add.jd = e.point.lng;
      this.add.wd = e.point.lat;
      this.zoom = e.target.getZoom();

      let geocoder = new BMap.Geocoder(); //创建地址解析器的实例
      geocoder.getLocation(e.point, (rs) => {
        this.shopForm.cityName = [
          rs.addressComponents.province,
          rs.addressComponents.city,
          rs.addressComponents.district,
        ];
        this.add.site = rs.address;
        this.add.lng = rs.point.lng;
        this.add.lat = rs.point.lat;
        this.shopForm.shopAddress = rs.address;
        let { lng, lat } = bd2gg(rs.point.lng, rs.point.lat);
        this.shopForm.longitude = lng;
        this.shopForm.latitude = lat;
      });
    },
    infoWindowClose() {
      this.show = false;
    },
    infoWindowOpen() {
      setInterval(() => {
        this.show = true;
      }, 100);
    },
    cityNameCascaderHandler(value) {
      console.log(value);
      this.mapCenter = value.join("");
    },
    // showDialogMap() {
    //   if (!this.shopForm.cityName) {
    //     this.$notify({
    //       title: "警告",
    //       message: "请先选择城市",
    //       type: "warning",
    //       duration: 6000,
    //     });
    //     return;
    //   }
    //   this.dialogMapVisible = true;
    // },
    saveStationAddress() {
      this.dialogMapVisible = false;
    },
    linkTo(path) {
      this.$router.push({
        path: path,
      });
    },
    windowOpen(url) {
      location.href = url;
    },
    nuonuoCheck() {
      this.submitForm("shopForm", (data) => {
        this.windowOpen(data.nuonuoVerifyUrl);
      });
    },
    close_uploadDialog() {
      this.isshow_uploadDialog = false;
      this.uploadDisabled = false;
    },
    show_uploadDialog(val, name) {
      console.log(val, name);
      this.ImgLimits = val;
      this.uploadName = name;
      this.isshow_uploadDialog = true;
      this.uploadDisabled = true;
      this.$refs.childRef.rSelect = []; //  每次打开清除上一次的选择
    },
    addDeliveryTemplateList() {
      this.shopForm.deliveryTemplate.push({
        from: 0,
        to: 0,
        unit: 0,
      });
    },
    delDeliveryTemplateList(index) {
      this.shopForm.deliveryTemplate.splice(index, 1);
    },
  },
};
</script>

<style lang="less" scoped>
.content-page {
  .tab-header {
    padding: 12px 20px;
  }
  .tab-content {
    padding: 40px 48px;
  }
  .shopsetting-form {
    width: 100%;
    .qrcode-img {
      display: inline-block;
      position: relative;
      left: 0px;
      bottom: 0px;
      width: 300px;
      height: 450px;
      margin-right: 10px;
      .bg {
        width: 100%;
        height: 100%;
      }
      .logo {
        position: absolute;
        width: 30px;
        height: 30px;
        right: 136px;
        left: 140.5px;
        top: 243px;
        border-radius: 4px;
      }
      .name {
        position: absolute;
        display: block;
        width: 172px;
        color: #d07910;
        font-size: 10.8px;
        bottom: 64px;
        left: 72px;
        text-align: center;
      }
      .phone {
        display: block;
        width: 100%;
        position: absolute;
        color: #d54538;
        font-size: 12px;
        bottom: 35px;
        left: 0;
        text-align: center;
        font-weight: bold;
      }
      .addresss {
        display: block;
        width: 100%;
        position: absolute;
        color: #d54538;
        font-size: 12px;
        bottom: 17px;
        left: 0;
        text-align: center;
        transform: scale(0.6);
        white-space: nowrap;
        overflow: hidden;
      }
      .info {
        display: block;
        width: 100%;
        position: absolute;
        color: #d54538;
        font-size: 12px;
        bottom: -1px;
        left: 0;
        text-align: center;
        transform: scale(0.6);
      }
      .scan-code-img {
        position: absolute;
        display: block;
        bottom: 147px;
        left: 111px;
      }
    }
    .el-form-item__content {
      .el-input,
      .el-textarea,
      .el-cascader {
        width: 380px;
      }
      .taxnum-input {
        width: 200px;
        margin-right: 10px;
      }
      .el-date-editor {
        width: 182px;
        margin-right: 14px;
      }
      .func-container {
        width: 144px;
        display: inline-block;
        height: 20px;
        line-height: 20px;
        margin-right: 20px;
      }
      .tips {
        font-size: 12px;
        line-height: 14px;
        color: #f56c6c;
        margin-left: 10px;
        & > i {
          margin-right: 6px;
        }
        .el-link {
          font-size: 14px;
          vertical-align: baseline;
          margin-left: 10px;
        }
      }
      .verified-status {
        margin-right: 18px;
      }
    }
    .submit-btn-container {
      margin: 40px 0 200px 0;
    }
    .inline-title {
      line-height: 40px;
      font-size: 14px;
      color: #333333;
      padding-left: 20px;
      background: #f8f8f8;
      margin: 45px 0 24px 0;
    }
    .el-radio {
      margin-right: 20px;
      &:last-child {
        margin-right: 0;
      }
    }
    .delivery-template {
      .item {
        margin-bottom: 8px;
        .button-del {
          margin-left: 10px;
          display: none;
        }
        &:hover {
          .button-del {
            display: inline-block;
          }
        }
      }
    }
  }
}
.map {
  width: 100%;
  height: 400px;
  　　/deep/ .anchorBL {
    display: none;
  }
}
</style>
<style lang="less">
.banner-image {
  .el-upload-list--picture-card .el-upload-list__item {
    width: 443px;
    height: 148px;
  }
}
</style>
